module.exports = __webpack_public_path__ + "img/whoareyou.272f3f65.png";